<!-- Header section (above map) -->
<div class="new-hop-header">
  <div class="container-padding mx-auto max-w-screen-desktop">
    <h1 class="new-hop-header__title">{{ 'newHop.title' | translate }}</h1>
    <p class="new-hop-header__sub">{{ 'newHop.selectOnMap' | translate }}</p>
    <p class="new-hop-header__note">{{ 'newHop.twoWeeks' | translate }}</p>
  </div>
</div>

<!-- Map + Panel area -->
<div class="new-hop container-padding mx-auto max-w-screen-desktop">

  <!-- ═══ Map ═══ -->
  <div class="new-hop__map">
    <div *ngIf="branchesLoading" class="new-hop__map-loading">
      <app-skeleton dimensions="w-full h-full"></app-skeleton>
    </div>
    <app-map
      *ngIf="branches && !branchesLoading"
      [toggleNewHop]="toggleNewHop.bind(this)"
      [newHopSelectabled]="branchesForMap"
      [newHop]="true"
      [branches]="branches"
      mapHeight="100%"
      class="w-full h-full block">
    </app-map>

    <!-- Floating badge (when panel collapsed) -->
    <div class="new-hop__badge" *ngIf="panelCollapsed && selections.length > 0" (click)="togglePanel()">
      <span class="new-hop__badge-count">{{ selections.length }}</span>
      <span class="new-hop__badge-text">{{ selections.length === 1 ? 'parada' : 'paradas' }} · {{ calculateTotal() | currency }}</span>
    </div>

    <!-- Toggle button -->
    <button class="new-hop__toggle" [class.new-hop__toggle--collapsed]="panelCollapsed" (click)="togglePanel()">
      <svg class="new-hop__toggle-icon" [class.new-hop__toggle-icon--open]="!panelCollapsed" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7"></path>
      </svg>
    </button>
  </div>

  <!-- ═══ Panel derecho ═══ -->
  <aside class="new-hop__panel" [class.new-hop__panel--collapsed]="panelCollapsed">
    <div class="new-hop__panel-inner">

      <!-- Close arrow (mobile only) -->
      <div class="new-hop__panel-close" (click)="togglePanel()">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7"></path>
        </svg>
      </div>

      <!-- Body -->
      <div class="new-hop__body">

        <div *ngIf="branchesLoading" class="new-hop__loading">
          <div *ngFor="let i of [1,2,3]" class="new-hop__card new-hop__card--skeleton">
            <app-skeleton dimensions="h-[36px] w-full rounded-lg"></app-skeleton>
          </div>
        </div>

        <div *ngIf="!branchesLoading && selections.length === 0" class="new-hop__empty">
          <p>{{ 'newHop.tapToAdd' | translate }}</p>
        </div>

        <div *ngIf="!branchesLoading && selections.length > 0" class="new-hop__list">
          <div *ngFor="let sel of selections; let i = index" class="new-hop__card">
            <div class="new-hop__card-row">
              <span class="new-hop__card-badge">{{ i + 1 }}</span>
              <div class="new-hop__card-info">
                <span class="new-hop__card-name">{{ sel.branchName }}</span>
                <span class="new-hop__card-cat">{{ sel.categoryName }} · {{ sel.price | currency }}</span>
              </div>
              <button (click)="toggleNewHop(sel.branchId)" class="new-hop__card-change">Cambiar</button>
              <button (click)="removeSelection(sel.branchId)" class="new-hop__card-remove">×</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="new-hop__footer" *ngIf="!branchesLoading && selections.length > 0">
        <div class="new-hop__footer-total">
          <span class="new-hop__footer-label">{{ 'newHop.total' | translate }}</span>
          <span class="new-hop__footer-amount">{{ calculateTotal() | currency }}</span>
        </div>

        <p *ngIf="!hasMinimumBreweries()" class="new-hop__footer-warn">
          {{ 'newHop.minBreweries' | translate: { min: minBreweries } }}
        </p>

        <button *ngIf="hasMinimumBreweries() && calculateTotal() > 0"
          (click)="addToCart()"
          class="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-full bg-[var(--secondary)] text-white font-bold text-[12px] uppercase shadow-[0_4px_0_0_var(--dark-orange)] hover:shadow-[0_6px_0_0_var(--dark-orange)] hover:-translate-y-1 active:translate-y-1 active:shadow-[0_2px_0_0_var(--dark-orange)] transition-all"
          title="{{ 'newHop.addToCart' | translate }}">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z"/>
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 1v4m0 0v4m0-4h4m-4 0H8"/>
          </svg>
          {{ 'newHop.addToCart' | translate }}
        </button>
      </div>
    </div>
  </aside>
</div>

<!-- ════════════════ MODAL: CATEGORÍAS ════════════════ -->
<div *ngIf="modalOpen && modalBranch"
     class="fixed inset-0 z-[1000] flex items-center justify-center"
     (click)="closeModal()">

  <div class="absolute inset-0 bg-black/50"></div>

  <div class="relative bg-white rounded-2xl shadow-2xl w-[92vw] max-w-[480px] max-h-[80vh] overflow-y-auto p-6 z-[1001]"
       (click)="$event.stopPropagation()">

    <div class="flex items-start justify-between mb-4">
      <div>
        <h3 class="text-[20px] font-bold uppercase">{{ modalBranch.brewery.name }}</h3>
        <p class="text-[13px] text-gray-500">{{ modalBranch.address }}</p>
        <p *ngIf="getSelectionForBranch(modalBranch.id) as sel"
           class="mt-1 text-[12px] text-[var(--secondary)] font-semibold">
          ✓ {{ sel.categoryName }}
        </p>
      </div>
      <button (click)="closeModal()"
        class="ml-4 text-gray-400 hover:text-gray-700 transition text-2xl leading-none font-light">✕</button>
    </div>

    <div *ngIf="modalCategories.length === 0" class="text-gray-500 text-[14px] py-4 text-center">
      {{ 'newHop.noCategories' | translate }}
    </div>

    <div class="flex flex-col gap-4">
      <div *ngFor="let bc of modalCategories"
           class="border-2 rounded-xl p-4 transition-all"
           [ngClass]="getSelectionForBranch(modalBranch.id)?.categoryId === bc.categoryId
             ? 'border-[var(--secondary)]'
             : 'border-[var(--grey)]'">

        <div class="flex items-center justify-between mb-2">
          <div>
            <p class="font-bold text-[15px]">{{ bc.category.name }}</p>
            <p class="text-[12px] text-gray-500">{{ bc.category.description }}</p>
          </div>
          <span class="font-bold text-[var(--black)] text-[18px]">{{ bc.price | currency }}</span>
        </div>

        <div class="flex flex-wrap gap-1.5 mb-3">
          <span *ngFor="let product of getAvailableProducts(modalBranch.id, bc)"
            class="px-2.5 py-1 rounded-full text-[11px] font-medium bg-[var(--light-grey)] text-[var(--black)] border border-[var(--grey)]">
            {{ product.name }}
          </span>
          <span *ngIf="getAvailableProducts(modalBranch.id, bc).length === 0"
            class="text-[12px] text-gray-400 italic">{{ 'newHop.noProductsListed' | translate }}</span>
        </div>

        <button (click)="selectCategory(bc)"
          class="w-full py-2 rounded-xl text-[13px] font-semibold transition-colors text-white"
          [ngClass]="getSelectionForBranch(modalBranch.id)?.categoryId === bc.categoryId
            ? 'bg-[var(--secondary)] opacity-80'
            : 'bg-[var(--secondary)] hover:opacity-90'">
          {{ getSelectionForBranch(modalBranch.id)?.categoryId === bc.categoryId ? ('newHop.selected' | translate) : ('newHop.select' | translate) }}
        </button>
      </div>
    </div>
  </div>
</div>
